import React, { useState, useEffect } from 'react';
import moment from "moment";
import Moment from "react-moment";
import {
  BreadcrumbPage
} from "../../shared";
import {
  Box,
  FormControlLabel,
  Checkbox,
  FormGroup,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,

} from '@material-ui/core';
import {

  FormLabel,
  FormControl,
  ListItemText,
  TextField,

  Select,
  InputLabel,
  MenuItem
} from '@mui/material';
import DatePicker from '@mui/lab/DatePicker';
import { useSelector, useDispatch } from 'react-redux';
import { getRequest, putRequest } from "../../services/ApiServices";
import { withStyles, makeStyles, useTheme } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import { render } from 'react-dom';
import UsersChart from './UsersChart';
import UsersByChart from './UsersByChart';
import SimpleMap from './SimpleMap';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import CancelIcon from '@mui/icons-material/Cancel';
import ZoomOutMapIcon from '@mui/icons-material/ZoomOutMap';
import axios from "axios";
import { getCookie } from "../../services/Cookies";
import { ToastError } from "../../services/ToastMsg";
import { LOADING } from "../../action";
import ReactTooltip from "react-tooltip";
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import MapChart from "./MapChart";

import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { ThemeProvider } from "@mui/styles";
import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import { getCurrentDate, getCurrentDateOfBelow } from "../../services/DateServices"
import MUIDataTable from "mui-datatables";
import {
  styled
} from '@mui/material/styles';
import {
  KeyboardDatePicker
} from "@material-ui/pickers";
const useStyles = makeStyles((theme) => ({
  tableBody: {
    "& .tss-10rusft-MUIDataTableToolbar-icon": {
      color: "#FF4717",
      boxShadow: "0px -1px 2px 0 #065881 inset, 0px 1px 1px 1px #ccc, 0 0 0 6px #fff, 0 2px 12px 8px #ddd",
      marginLeft: "15px"
    },
    "& .tss-9z1tfs-MUIDataTableToolbar-iconActive": {
      color: "#FF4717",
      boxShadow: "0px -1px 2px 0 #065881 inset, 0px 1px 1px 1px #ccc, 0 0 0 6px #fff, 0 2px 12px 8px #ddd",
      marginLeft: "15px"
    },
    "& .tss-qbo1l6-MUIDataTableToolbar-actions": {
      justifyContent: "left",
      position: "absolute",
    },
    "& .tss-1ufdzki-MUIDataTableSearch-main": {
      marginRight: "10px",
      width: 500
    },
    "& .tss-1fz5efq-MUIDataTableToolbar-left ": {
      position: "absolute",
      right: 20
    },
   
  },
  AnalyticstableBody: {
    "& .tss-10rusft-MUIDataTableToolbar-icon": {
      color: "#FF4717",
      boxShadow: "0px -1px 2px 0 #065881 inset, 0px 1px 1px 1px #ccc, 0 0 0 6px #fff, 0 2px 12px 8px #ddd",
      marginLeft: "15px"
    },
    "& .tss-9z1tfs-MUIDataTableToolbar-iconActive": {
      color: "#FF4717",
      boxShadow: "0px -1px 2px 0 #065881 inset, 0px 1px 1px 1px #ccc, 0 0 0 6px #fff, 0 2px 12px 8px #ddd",
      marginLeft: "15px"
    },
    "& .tss-qbo1l6-MUIDataTableToolbar-actions": {
      justifyContent: "left",
      position: "absolute",
    },
    "& .tss-1ufdzki-MUIDataTableSearch-main": {
      marginRight: "10px",
      width: 500
    },
    "& .tss-1fz5efq-MUIDataTableToolbar-left ": {
      position: "absolute",
      right: 20
    },
    "& .css-12wnr2w-MuiButtonBase-root-MuiCheckbox-root.Mui-checked": {
      color: "#1976d2",
  },
},
  mainBox: {
    boxShadow: "4px 4px 8px 1px #b9b8b8",
    height: "71vh",
  },
  boxLayout: {
    backgroundColor: "#fff",
    boxShadow: "1px 1px 4px 2px #a1a1a1",
    borderRadius: 8,
    margin: "5px",
    cursor: "pointer",
  }, boxLayout_1: {
    backgroundColor: "#fff",
    boxShadow: "1px 1px 4px 2px #a1a1a1",
    borderRadius: 8,
    margin: "5px",
    cursor: "pointer",
  },
  cont2: {
    width: "250px",
    height: "250px",
    margintop: "50px",
    marginleft: "150px",
  },
  heading: {
    padding: "1px",
    color: "#ff4717 ",
    fontWeight: "bold"
  },
  btnStyle2: {
    borderRadius: "8px",
    border: "2px solid #ff4717",
    boxShadow: "2px 2px 4px 2px #dadada",
    color: "#ffffff !important",
    background: "#ff4717 !important",
    textTransform: "capitalize",
    padding: "4px 22px",
  },
  justifyContentBetween: {
    justifyContent: "space-between!important",
  },
  overflowHidden: {
    overflow: "hidden",
    height: "20px",
  },
  tableLayout: {
    boxShadow: "0 0 0 0 #fff !important",
  },
  table: {
    minWidth: 650,
  },

}));

/* const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
})); */

function UserAnalytics() {
  const BreadcrumbList = [{ name: "Analytics", url: "" }];
  const classes = useStyles();
  const dispatch = useDispatch();
  let theme = createTheme();
  theme = responsiveFontSizes(theme)
  const [value, setValue] = React.useState(0);
  const [open, setOpen] = React.useState(false);
  const [fullWidth, setFullWidth] = React.useState(true);
  const [dialogContent, setDialogContent] = React.useState(null);
  const [chartDetails, setChatDetails] = React.useState({ title: "", datatype: "" });
  const detailsList = [{ title: "Users By Chart" }, { title: "Users By Type", datatype: "usersbyusertype" }, { title: "Users By Country", datatype: "usersbycountry" }, { title: "Users By Role", datatype: "usersbyrole" }, { title: "Users By Device", datatype: "usersbydevice" }, { title: "Users By Browser", datatype: "usersbybrowser" }, { title: "Users By Client", datatype: "usersbyclient" }, { title: "Users By OS", datatype: "usersbyoperatingsystem" }, { title: "Users By loginfailed", datatype: "usersbyloginfailed" }, { title: "Users Per Month", datatype: "userspermonth" }]
  const [chartlist, setChartList] = React.useState({ chart1: [], chart2: [] })
  const [Userbyrolechart, setUserbyrolechart] = React.useState();
  const [Userbyclientchart, setUserbyclientchart] = React.useState();
  const [Userbyusertypechart, setUserbyusertypechart] = React.useState();
  const [Userbydevicechart, setUserbydevicechart] = React.useState();
  const [Userbyoschart, setUserbyoschart] = React.useState();
  const [Userbycountrychart, setUserbycountrychart] = React.useState();
  const [Userbybrowserchart, setUserbybrowserchart] = React.useState();
  const [loginuserchart, setloginuserchart] = React.useState();
  const [Usermap, setUsermap] = React.useState();
  const [Analyticstable, setAnalyticstable] = React.useState();
  const [dialogcharts, setDialogCharts] = React.useState();
  const [loginfaileddetails, setloginfaileddetails] = React.useState();
  const [userspermonth, setuserspermonth] = React.useState();
  const [loginfailedtable, setloginfailedtable] = React.useState([]);
  const [content, setContent] = useState("");
  const [formObj, setFormObj] = useState({ StartDate: getCurrentDateOfBelow(365), EndDate: getCurrentDate() });
  const [isrender, setisrender] = useState(false)

  const StyledTableCell = withStyles((theme) => ({
    head: {
      backgroundColor: "#ddd",
      fontWeight: "bold",
    },
    body: {
      fontSize: 14,
    },
  }))(TableCell);

  const getMuiTheme = () => createTheme({

    overrides: {
      MUIDataTableHeadCell: {
        root: {
          textTransform: "none"
        }
      }
    }
  })
  const columns = [
    {
      name: "username",
      label: "User Name",
      options: {
        filter: true,
        sort: true,

      }
    }, {
      name: "userrole",
      label: "User role",
      options: {
        filter: true,
        sort: true,

      }
    }, {
      name: "clientname",
      label: "Client Name",
      options: {
        filter: true,
        sort: true,

      }
    }, {
      name: "ipaddress",
      label: "IP Address",
      options: {
        filter: true,
        sort: true,

      }
    },
    {
      name: "activity",
      label: "Activity ",
      options: {
        filter: true,
        sort: true,

      }
    },
    {
      name: "date",
      label: "Date ",
      options: {
        filter: true,
        // filterOptions: {

        //   renderValue: (value) => {
        //     return <Moment format="DD/MM/YYYY">{value}</Moment>
        //   }
        // },
        // customBodyRender: (value, tableMeta, updateValue) => {

        //   return <Moment format="DD/MM/YYYY">{value}</Moment>
        // }



      }
    }, {
      name: "country",
      label: "Country ",
      options: {
        filter: true,
        sort: true,

      }
    }, {
      name: "region",
      label: "Region ",
      options: {
        filter: true,
        sort: true,

      }
    }, {
      name: "city",
      label: "City ",
      options: {
        filter: true,
        sort: true,
      }
    }, {
      name: "zip",
      label: "Zip ",
      options: {
        filter: true,
        sort: true,
      }
    }, {
      name: "lat",
      label: "Latitude ",
      options: {
        filter: true,
        sort: true,
      }
    }, {
      name: "longitude",
      label: "Longitude ",
      options: {
        filter: true,
        sort: true,
      }
    }, {
      name: "userAgent",
      label: "User Agent ",
      options: {
        filter: true,
        sort: true,
      }
    }, {
      name: "os",
      label: "OS",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "sessionKey",
      label: "sessionKey",
      options: {
        filter: true,
        sort: true,
      }
    }];
    const[AnalyticsUser,SetAnalyticsUser] = useState([]);
    const[SelectedRowsAnalytics,setSelectedRowsAnalytics]=React.useState([]);
  

  const options = {
    customToolbarSelect:()=>{
    <>
    onRowsDelete:True,
    </>
    
  },
  rowsSelected:SelectedRowsAnalytics,
  selectToolbarPlacement:"above",
selectableRows:"multiple",
    filter: true,
    responsive: 'standard',
    filterType: 'multiselect',
    rowsPerPageOptions: [10, 15, 50, 100],
    downloadOptions:{
      filterOptions:{
        useDisplayedColumnsOnly:true,
        useDisplayedRowsOnly:true
      }
    },
      onRowSelectionChange:(currentRowsSelected,allRowsSelected,rowsSelected)=>{
        let isExist=[];
        rowsSelected.forEach((d)=>{
        isExist.push(Analyticstable[d]);
      })
    
      SetAnalyticsUser(isExist)
      setSelectedRowsAnalytics([... rowsSelected])
    },
    
      onDownload:(buildHead, buildBody,columns, gridData)=>{
        
        var myData= [];
        // var newKeys = Object.keys(loginfailedtable[0]);
        var idx = 0;
        var columnsExport = [];
        var columnsExport1 = [];
        columnsExport.push("");
        columns.forEach((cl) => {
          //if(cl.label!=="Customer Contract")
            columnsExport.push(cl.label);
            console.log("col",columnsExport)
        

          // columnsExport.push(cl.label);
          
        })
        // newKeys.forEach((k) => {
        //   columnsExport.push(k);
        // });
        columnsExport.push("\n");
       let i = 0;
       
        //console.log(item);
      AnalyticsUser.length>0?
        (
          AnalyticsUser.forEach((item) => {
        let visibleRows = gridData.filter((df) => {
          let dfdt = df.data;
          if (dfdt[0] == item.username && dfdt[1] == item.userrole)
            return true;
          else
            return false;
    
        });
       if (visibleRows.length > 0) {
        
        let itemData = { ...item };
        let dataItem = []
        if (i == 0)
          dataItem.push("");
        i++;
        itemData.clientname = itemData.clientname?.replace(/,/g, "");
       let objsample={
        username:itemData.username,
        userrole:itemData.userrole,
        clientname:itemData.clientname,
        ipaddress:itemData.ipaddress,
        activity:itemData.activity,
        Date:itemData.date,
        country:itemData.country,
        region:itemData.region,
        city:itemData.city,
        zip:itemData.zip,
        latitude:itemData.lat,
        longitude:itemData.longitude,
        userAgent:itemData.userAgent,
        os:itemData.os,
        sessionKey:itemData.sessionKey
       }
       
          let data = [];
          data.push(...Object.values({ ...objsample}));
          data.push("\n");
          dataItem.push(data);
        // });
        myData.push(...dataItem);
        // console.log("myData",myData)
       }
    })
        ):(
        
          Analyticstable.forEach((item) => {
            debugger
          let visibleRows = gridData.filter((df) => {
            let dfdt = df.data;
            if (dfdt[0] == item.username && dfdt[1] == item.userrole)
              return true;
            else
              return false;
      
          });
         if (visibleRows.length > 0) {
          
          let itemData = { ...item };
          let dataItem = []
          if (i == 0)
            dataItem.push("");
          i++; 
      // itemData.portName=itemData.portName.replace(/./g,"");
      itemData.clientname = itemData.clientname?.replace(/,/g, "");
      let objsample={
        username:itemData.username,
        userrole:itemData.userrole,
        clientname:itemData.clientname,
        ipaddress:itemData.ipaddress,
        activity:itemData.activity,
        Date:itemData.date,
        country:itemData.country,
        region:itemData.region,
        city:itemData.city,
        zip:itemData.zip,
        latitude:itemData.lat,
        longitude:itemData.longitude,
        userAgent:itemData.userAgent,
        os:itemData.os,
        sessionKey:itemData.sessionKey
           }
         
            let data = [];
            data.push(...Object.values({ ...objsample}));
            data.push("\n");
            dataItem.push(data);
          // });
          myData.push(...dataItem);
          // console.log("myData",myData)
         }
        })
        )
    buildHead = () => {
    console.log(columnsExport);
    return columnsExport;
    }
    buildBody = () => {
    // console.log(myData);
    return  myData;
    }
    return buildHead() + buildBody();
      }

     };
    // setFilterChipProps: (colIndex, colName, data) => {
    //   ////console.log(colIndex, colName, data);
    //   return {
    //     color: 'primary',
    //     variant: 'outlined',
    //     className: 'testClass123',
    //   };
    // }

  const handleClickOpen = (idx, index) => {
    //
    if (index == "usersbyrole") {
      setDialogCharts(Userbyrolechart)
    } else if (index == "usersbydevice") {
      setDialogCharts(Userbydevicechart)
    } else if (index == "usersbycountry") {
      setDialogCharts(Userbycountrychart)
    } else if (index == "usersbybrowser") {
      setDialogCharts(Userbybrowserchart)
    } else if (index == "usersbyclient") {
      setDialogCharts(Userbyclientchart)
    } else if (index == "usersbyoperatingsystem") {
      setDialogCharts(Userbyoschart)
    } else if (index == "usersbyusertype") {
      setDialogCharts(Userbyusertypechart);
    } else if (index == 'usersbyloginfailed') {
      setDialogCharts(loginfaileddetails)
    } else if (index == 'userspermonth') {
      setDialogCharts(userspermonth)
    }
    setChatDetails(detailsList[idx]);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const getUserbyrole = () => {
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Analytics/AnalyticsClientRoles/${formObj.StartDate}/${formObj.EndDate}`;
    dispatch({ type: LOADING, payload: true });
    getRequest(url)
      .then((res) => {
        if (res.data) {
          let outputData = [];
          outputData.push(["Role", "Role"]);
          for (var i = 0; i < res.data.length; i++) {
            var input = res.data[i];
            outputData.push([input.name, input.count]);
          }
          setUserbyrolechart(outputData);
          let local = chartlist;
          local["chart1"] = outputData;
          setChartList(...chartlist, ...local);
          // dispatch({ type: LOADING, payload: false });
        } else {
          // dispatch({ type: LOADING, payload: false });
          ToastError(res.data.message);
        }
      })
      .catch((error) => {
        // dispatch({ type: LOADING, payload: false });
      });
  }
  const getclientuser = () => {
    //
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Analytics/AnalyticsClientusers/${formObj.StartDate}/${formObj.EndDate}`;
    dispatch({ type: LOADING, payload: true });
    getRequest(url)
      .then((res) => {
        if (res.data) {
          let outputData = [];
          outputData.push(["Client", "Active Users", "Registered Users"]);
          for (var i = 0; i < res.data.length; i++) {
            var input = res.data[i];
            outputData.push([input.name, input.activeUsers, input.registeredUsers]);
          }
          setUserbyclientchart(outputData);
          // dispatch({ type: LOADING, payload: false });
        } else {
          // dispatch({ type: LOADING, payload: false });
          ToastError(res.data.message);
        }
      })
      .catch((error) => {
        // dispatch({ type: LOADING, payload: false });
      });
  }
  const getusertype = () => {
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Analytics/Analyticsuserbyusertype/${formObj.StartDate}/${formObj.EndDate}`;
    dispatch({ type: LOADING, payload: true });
    getRequest(url)
      .then((res) => {
        if (res.data) {
          let outputData = [];
          outputData.push(["UserType", "UserType"]);
          for (var i = 0; i < res.data.length; i++) {
            var input = res.data[i];
            outputData.push([input.name, input.count]);
          }
          setUserbyusertypechart(outputData);
          // dispatch({ type: LOADING, payload: false });
        } else {
          // dispatch({ type: LOADING, payload: false });
          ToastError(res.data.message);
        }
      })
      .catch((error) => {
        // dispatch({ type: LOADING, payload: false });
      });
  }
  const getuserbydevice = () => {
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Analytics/Analyticsuserbydevice/${formObj.StartDate}/${formObj.EndDate}`;
    dispatch({ type: LOADING, payload: true });
    getRequest(url)
      .then((res) => {
        if (res.data) {
          let outputData = [];
          outputData.push(["Device", ""]);
          for (var i = 0; i < res.data.length; i++) {
            var input = res.data[i];
            outputData.push([input.name, input.count]);
          }
          setUserbydevicechart(outputData);
          // dispatch({ type: LOADING, payload: false });
        } else {
          // dispatch({ type: LOADING, payload: false });
          ToastError(res.data.message);
        }
      })
      .catch((error) => {
        // dispatch({ type: LOADING, payload: false });
      });
  }
  const getuserbyoperatingsystem = () => {
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Analytics/Analyticsuserbyoperatingsystem/${formObj.StartDate}/${formObj.EndDate}`;
    dispatch({ type: LOADING, payload: true });
    getRequest(url)
      .then((res) => {
        if (res.data) {
          let outputData = [];
          outputData.push(["OperatingSystem", ""]);
          for (var i = 0; i < res.data.length; i++) {
            var input = res.data[i];
            outputData.push([input.name, input.count]);
          }
          setUserbyoschart(outputData);
          // dispatch({ type: LOADING, payload: false });
        } else {
          // dispatch({ type: LOADING, payload: false });
          ToastError(res.data.message);
        }
      })
      .catch((error) => {
        // dispatch({ type: LOADING, payload: false });
      });
  }
  const getuserbycountry = () => {
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Analytics/Analyticsuserbycountry/${formObj.StartDate}/${formObj.EndDate}`;
    dispatch({ type: LOADING, payload: true });
    getRequest(url)
      .then((res) => {
        if (res.data) {
          let outputData = [];
          outputData.push(["Country", "Country"]);
          for (var i = 0; i < res.data.length; i++) {
            var input = res.data[i];
            outputData.push([input.name, input.count]);
          }
          setUserbycountrychart(outputData);
          // dispatch({ type: LOADING, payload: false });
        } else {
          // dispatch({ type: LOADING, payload: false });
          ToastError(res.data.message);
        }
      })
      .catch((error) => {
        // dispatch({ type: LOADING, payload: false });
      });
  }
  const getuserbybrowser = () => {
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Analytics/Analyticsuserbybrowser/${formObj.StartDate}/${formObj.EndDate}`;
    dispatch({ type: LOADING, payload: true });
    getRequest(url)
      .then((res) => {
        if (res.data) {
          let outputData = [];
          outputData.push(["Browser", "Browser"]);
          for (var i = 0; i < res.data.length; i++) {
            var input = res.data[i];
            outputData.push([input.name, input.count]);
          }
          setUserbybrowserchart(outputData);
          // dispatch({ type: LOADING, payload: false });
        } else {
          // dispatch({ type: LOADING, payload: false });
          ToastError(res.data.message);
        }
      })
      .catch((error) => {
        // dispatch({ type: LOADING, payload: false });
      });
  }
  const getloginusers = () => {
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Analytics/Analyticsloginuser`;
    dispatch({ type: LOADING, payload: true });
    getRequest(url)
      .then((res) => {
        if (res.data) {
          // let outputData =(Object.entries(res.data[0]));
          setloginuserchart(res.data[0]);
          // dispatch({ type: LOADING, payload: false });
        } else {
          // dispatch({ type: LOADING, payload: false });
          ToastError(res.data.message);
        }
      })
      .catch((error) => {
        // dispatch({ type: LOADING, payload: false });
      });
  }
  const getusersmap = () => {

    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Analytics/Analyticsusersmap`;
    dispatch({ type: LOADING, payload: true });
    getRequest(url)
      .then((res) => {
        if (res.data) {
          setUsermap(res.data);
          // dispatch({ type: LOADING, payload: false });
        } else {
          // dispatch({ type: LOADING, payload: false });
          ToastError(res.data.message);
        }
      })
      .catch((error) => {
        // dispatch({ type: LOADING, payload: false });
      });
  }
  const getanalyticstable = () => {
    //
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Analytics/Analyticstable/${formObj.StartDate}/${formObj.EndDate}`;
    dispatch({ type: LOADING, payload: true });
    getRequest(url)
      .then((res) => {
        if (res.data) {
          setAnalyticstable(res.data);
          // dispatch({ type: LOADING, payload: false });
          // console.log(res.data)
          res.data.forEach((d) => {
            d.date = moment(d.date).format('DD/MM/YYYY');
          })

        } else {
          // dispatch({ type: LOADING, payload: false });
          ToastError(res.data.message);
        }
      })
      .catch((error) => {
        // dispatch({ type: LOADING, payload: false });
      });
  }

  const getloginfaileddetails = () => {
    // //;
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Analytics/Analyticsloginfaileddetails/${formObj.StartDate}/${formObj.EndDate}`;
    dispatch({ type: LOADING, payload: true });
    getRequest(url)
      .then((res) => {
        if (res.data) {
          let outputData = [];
          outputData.push(["Device", ""]);
          for (var i = 0; i < res.data.length; i++) {
            var input = res.data[i];
            outputData.push([input.name, input.count]);
          }
          setloginfaileddetails(outputData);
         
          // dispatch({ type: LOADING, payload: false });
        } else {
          // dispatch({ type: LOADING, payload: false });
          ToastError(res.data.message);
        }
      })
      .catch((error) => {
        // dispatch({ type: LOADING, payload: false });
      });
  }
  const getloginfailedtable = () => {
    // //;
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Analytics/Analyticsloginfailedtable`;
    dispatch({ type: LOADING, payload: true });
    getRequest(url)
      .then((res) => {
        if (res.data) {
          setloginfailedtable(res.data);
          // console.log(res.data);
          res.data.forEach((d) => {
            d.timestamp = moment(d.timestamp).format('DD/MM/YYYY');
          })

          // dispatch({ type: LOADING, payload: false });
        
        } else {
          // dispatch({ type: LOADING, payload: false });
          ToastError(res.data.message);
        }
      })
      .catch((error) => {
        // dispatch({ type: LOADING, payload: false });
      });
  }
  const getuserspermonth = () => {
    //
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Analytics/AnalyticsUserCreation/${formObj.StartDate}/${formObj.EndDate}`;
    dispatch({ type: LOADING, payload: true });
    getRequest(url)
      .then((res) => {
        if (res.data) {
          let outputData = [];
          outputData.push(["Date", "Active Users","Registered Users"]);
          for (var i = 0; i < res.data.length; i++) {
            var input = res.data[i];
            var dt = moment(input.date).format('MMM-YYYY');
            outputData.push([dt,input.activeUsers, input.registeredUsers ]);
          }
          var registereduserstemp = outputData.reduce(function (obj, cur) {
            if (cur[0] !== "Date") {
              var tot = obj[cur[0]] || 0;
              obj[cur[0]] = tot + cur[2];
              return obj;
            }
            else {
              var total = obj[cur[0]] || "";
              obj[cur[0]] = total + cur[2];
              return obj;
            }
          }, {});

          var activeuserstemp = outputData.reduce(function (obj, cur) {
            if (cur[0] !== "Date") {
              var tot = obj[cur[0]] || 0;
              obj[cur[0]] = tot + cur[1];
              return obj;
            }
            else {
              var total = obj[cur[0]] || "";
              obj[cur[0]] = total + cur[1];
              return obj;
            }
          }, {});

          var registerdresult = Object.keys(registereduserstemp).map(function (key) { return [key, registereduserstemp[key]]; })
          var activeresult = Object.keys(activeuserstemp).map(function (key) { return [key, activeuserstemp[key]]; })
          var result = [];
          for (var i = 0; i < registerdresult.length; i++) {
            result[i] = [...new Set([...activeresult[i], ...registerdresult[i]])];
          }
          for (var i = 0; i < result.length; i++) {
            if(result[i].length==2){
              result[i].push(result[i][1])
            }
          }
          setuserspermonth(result);
          dispatch({ type: LOADING, payload: false });
        } else {
          // dispatch({ type: LOADING, payload: false });
          ToastError(res.data.message);
        }
      })
      .catch((error) => {
        // dispatch({ type: LOADING, payload: false });
      });
  }
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  };
  function a11yProps(index) {

    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }
  useEffect(() => {
    getUserbyrole();
    getclientuser();
    getusertype();
    getuserbydevice();
    getuserbyoperatingsystem();
    getuserbycountry();
    getuserbybrowser();
    getloginusers();
    getusersmap();
    getanalyticstable();
    getloginfaileddetails();
    getloginfailedtable();
    getuserspermonth();
  }, []);

  useEffect(() => {
    ReactTooltip.rebuild();
  }, [content])

  const column = [
    {
      name: "username",
      label: "User Name",
      options: {
        filter: true,
        sort: true,

      }
    },
    {
      name: "timestamp",
      label: "Timestamp",
      options: {
        filter: true,
        sort: true,
        // filterOptions: {

        //   renderValue: (value) => {
        //     return <Moment format="DD/MM/YYYY">{value}</Moment>
        //   }
        // },
        // customBodyRender: (value) => {
        //   return <Moment format="DD/MM/YYYY">{value}</Moment>

        // }
      }
    },
    {
      name: "email",
      label: "	Email",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "customername",
      label: "	Customer Name",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "location",
      label: "Location",
      options: {
        filter: true,
        sort: true,
      }
    },
  ];  


  const[User,SetUser]=React.useState([]);
  const[SelectedRows,setSelectedRows]=React.useState([]);
  

  const option = {
    customToolbarSelect:()=>{
      <>
      onRowsDelete:True,
      </>
      
    },
    rowsSelected:SelectedRows,
    serverSide:false,
    selectToolbarPlacement:"above",
    selectableRows:"multiple",
    responsive: 'standard',
    filterType: 'multiselect',
    rowsPerPageOptions: [10, 15, 50, 100],
    textLabels: 'label',
    downloadOptions: {
      
      filterOptions: {
        useDisplayedColumnsOnly: true,
        useDisplayedRowsOnly: true
      }
    },
     
    onRowSelectionChange:(currentRowsSelected,allRowsSelected,rowsSelected)=>{
      let isExist=[];
      rowsSelected.forEach((d)=>{
      isExist.push(loginfailedtable[d]);
      console.log("oginfailedtable",isExist)
    })
      SetUser(isExist)
      // setSelectedRegisteredUsers([...isUserList]);
      setSelectedRows([...rowsSelected])
  },
  
    onDownload:(buildHead, buildBody,columns, gridData)=>{
      
      var myData= [];
      // var newKeys = Object.keys(loginfailedtable[0]);
      var idx = 0;
      var columnsExport = [];
      var columnsExport1 = [];
      columnsExport.push("");
      columns.forEach((cl) => {
        //if(cl.label!=="Customer Contract")
        columnsExport.push(cl.label);
  
      })
      // newKeys.forEach((k) => {
      //   columnsExport.push(k);
      // });
      columnsExport.push("\n");
     let i = 0;
     
      //console.log(item);
      User.length>0?
      (
        User.forEach((item) => {
      let visibleRows = gridData.filter((df) => {
        let dfdt = df.data;
        if (dfdt[0] == item.username && dfdt[1] == item.timestamp)
          return true;
        else
          return false;
  
      });
     if (visibleRows.length > 0) {
      
      let itemData = { ...item };
      let dataItem = []
      if (i == 0)
        dataItem.push("");
      i++;
      itemData.customername = itemData.customername.replace(/,/g, "");
     
      let objsample={
      username:itemData.username,
      timestamp:itemData.timestamp,
      email:itemData.email,
      customername:itemData.customername,
      location:itemData.location,
     }
     
        let data = [];
        data.push(...Object.values({ ...objsample}));
        data.push("\n");
        dataItem.push(data);
      // });
      myData.push(...dataItem);
      // console.log("myData",myData)
     }
  })
      ):(
      
        loginfailedtable.forEach((item) => {
          debugger
        let visibleRows = gridData.filter((df) => {
          let dfdt = df.data;
          if (dfdt[0] == item.username && dfdt[1] == item.timestamp)
            return true;
          else
            return false;
    
        });
       if (visibleRows.length > 0) {
        
        let itemData = { ...item };
        let dataItem = []
        if (i == 0)
          dataItem.push("");
        i++; 
        itemData.customername = itemData.customername.replace(/,/g, "");
        
    let objsample={
          username:itemData.username,
          timestamp:itemData.timestamp,
          email:itemData.email,
          customername:itemData.customername,
          location:itemData.location,
         }
       
          let data = [];
          data.push(...Object.values({ ...objsample}));
          data.push("\n");
          dataItem.push(data);
        // });
        myData.push(...dataItem);
        // console.log("myData",myData)
       }
      })
      )
  buildHead = () => {
  console.log(columnsExport);
  return columnsExport;
  }
  buildBody = () => {
  // console.log(myData);
  return  myData;
  }
  return buildHead() + buildBody();
    }
  };
  const handleDateData = (event, type) => {
    ////
    let dateFormat = "";
    if (event) {
      dateFormat = event.format('yyyy-MM-DD');
    }
    setFormObj({ ...formObj, [type]: dateFormat });
    //formObj[type]=dateFormat;
    //setFormObj(formObj);
    setisrender(!isrender);
    // //console.log(formObj,...formObj);
  }
  //const dummydata = [['Date','Active User','Registered User'],['AIDA CRUISES',4,2],
  //['ALTERA INFRASTRUCTURE NORWAY AS',5,1],['ANCORA INVESTMENT TRUST INC.',5,7],['ARAB MARITIME PETROLEUM TRANSPORT CO.',5,3]];
  const AnalyticFilter = () => {

    getUserbyrole();
    getclientuser();
    getusertype();
    getuserbydevice();
    getuserbyoperatingsystem();
    getuserbycountry();
    getuserbybrowser();
    getloginfaileddetails();
    getuserspermonth();
    getanalyticstable();

  }
  return (    
    <>

      <Grid  className="reportstablehead" spacing={3}>
        <BreadcrumbPage rows={BreadcrumbList} />
        <Grid>
          <Box  pb={3}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12} md={12}>
                <Box p={2} height={1}  className={classes.boxLayout}>
                  <Box component="h2" m={0} className="blcopy" fontWeight="500" pb={0}>
                    Filters:
                  </Box>
                  <Box display="block">
                    <Box pb={1}>

                      <Grid container spacing={3}>
                        <Grid item >
                          <Box component="span" className="date-input" mr={3} fontSize="18px" >
                            Date
                          </Box>
                        </Grid>
                        <Grid item >
                          <Box component="span" className="date-input" mr={2}>
                            <KeyboardDatePicker
                              margin="normal"
                              className="mar0"
                              id="date-picker-dialog"
                              // label="Date picker dialog"
                              format="DD/MM/YYYY"
                              invalidDateMessage=""
                              value={formObj.StartDate}
                              onChange={(event) => { handleDateData(event, "StartDate") }}
                              KeyboardButtonProps={{
                                'aria-label': 'change date',
                              }}
                            />
                          </Box>
                        </Grid>
                        <Grid item >
                          <Box component="span" className="date-input" mr={2} >
                            <KeyboardDatePicker
                              margin="normal"
                              id="date-picker-dialog"
                              // label="Date picker dialog"
                              format="DD/MM/YYYY"
                              className="mar0"  
                              invalidDateMessage=""
                              value={formObj.EndDate}
                              onChange={(event) => { handleDateData(event, "EndDate") }}
                              KeyboardButtonProps={{
                                'aria-label': 'change date',
                              }}
                            />
                          </Box>
                        </Grid>
                        <Grid item >
                          <Grid spacing={3}  >
                            <Button type="button" style={{ fontFamily: "white" }} className={classes.btnStyle2} onClick={AnalyticFilter}>
                              Apply Filter
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>

                    </Box>
                    {/* <Box component="div" >
                        <Grid container spacing={3} className="reports-filter-row mlr2" alignItems="left" >
                          <Grid spacing={3}  >
                            <Button type="button" className={classes.btnStyle2}>
                              Apply Filter
                            </Button>
                          </Grid>
                        </Grid>
                      </Box> */}


                  </Box>

                </Box>
              </Grid>

            </Grid>
          </Box>
        </Grid>
        <AppBar position="static" className="custom-tabs">
          <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
            <Tab label="Dashboard" {...a11yProps(0)} />
            <Tab label="Analytics" {...a11yProps(1)} />
            {/* <Tab label="MGO" {...a11yProps(2)} /> */}
            {/* <Tab label="LNG" {...a11yProps(3)} /> */}

          </Tabs>

        </AppBar>
        <Dialog
          fullWidth={fullWidth}
          maxWidth="xl"
          fullScreen={true}
          open={open}
          onClose={handleClose}
        >
          <DialogActions>
            <Button onClick={handleClose}><CancelIcon /></Button>
          </DialogActions>

          <DialogContent>
            {!chartDetails.datatype && loginuserchart ? (<UsersChart title="Users By Chart" chartData={loginuserchart}></UsersChart>) : (<UsersByChart title={chartDetails.title} datatype={chartDetails.datatype} chartData={dialogcharts}></UsersByChart>)}
            {/* <UsersByChart title="Users By Country" datatype="usersbycountry"></UsersByChart> */}
          </DialogContent>

        </Dialog>
        <TabPanel value={value} index={0} className="custom-tab-section">

          {/* <p className={classes.heading}>* This Analytics Dashboard chart showa last 6 months Data</p> */}
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={12} >


              <Box p={2} className={classes.boxLayout} style={{ height: "510px" }} >
                <Grid item xs={12} sm={12} md={12}>
                  <Grid direction="row" container spacing={1} >
                    <Grid item xs={12} sm={12} md={12}>
                      <p><b>New Registered Users</b> </p>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <Box component="div" className="text-right" >
                        <Button>
                          <ZoomOutMapIcon style={{ float: "right" }} onClick={() => handleClickOpen(9, "userspermonth")} />
                          {/* <p style={{color: "#080808" }}>Analysis</p> */}
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>

                </Grid>

                <UsersByChart title="Users Per Month" datatype="userspermonth" chartData={userspermonth}></UsersByChart>


              </Box>

            </Grid>
            <Grid item xs={5} sm={5} md={5} >


              <Box p={2} className={classes.boxLayout} style={{ height: "468px" }} >
                <Grid item xs={12} sm={12} md={12}>
                  <Grid direction="row" container spacing={1} >
                    <Grid item xs={8} sm={8} md={8}>
                      <p><b>Analytics Users By Count </b> </p>
                    </Grid>
                    <Grid item xs={4} sm={4} md={4}>
                      <Box component="div" className="text-right" >
                        <Button>
                          <ZoomOutMapIcon style={{ float: "right" }} onClick={() => handleClickOpen(0)} />
                          {/* <p style={{color: "#080808" }}>Analysis</p> */}
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>

                </Grid>
                {loginuserchart ? (<UsersChart title="Users By Chart" datatype="userlogindetails" chartData={loginuserchart}></UsersChart>) : ""}


              </Box>

            </Grid>
            <Grid item xs={7} sm={7} md={7} >

              <Box p={2} className={classes.boxLayout} style={{ height: "468px" }} >
                <Grid item xs={12} sm={12} md={12}>
                  <Grid direction="row" container spacing={1} >
                    <Grid item xs={8} sm={8} md={8}>
                      <p><b>Top 10 Client users and Registered users </b> </p>
                    </Grid>
                    <Grid item xs={4} sm={4} md={4}>
                      <Box component="div" className="text-right" >
                        <Button >
                          <ZoomOutMapIcon style={{ float: "right" }} onClick={() => handleClickOpen(6, "usersbyclient")} />
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
                <UsersByChart  datatype="usersbyclient" chartData={Userbyclientchart}></UsersByChart>
              </Box>




            </Grid>
            <Grid item xs={12} sm={12} md={12} >
              <Box p={2} className={classes.boxLayout_1} >
                <Grid item xs={10} sm={10} md={10} >
                  <Grid item xs={8} sm={8} md={8}>
                    <p><b>Analytics Users By Location </b> </p>
                  </Grid>
                  <Box>
                    <div>
                      <MapChart title="Users map " datatype="usersbymap" chartData={Usermap} setTooltipContent={setContent} />
                 
                      <ReactTooltip>{content}</ReactTooltip>
                    </div>
                  </Box>



                </Grid>
              </Box>
            </Grid>
            <Grid item xs={7} sm={7} md={7}>

              <Box p={2} className={classes.boxLayout} style={{ height: "468px" }} >
                <Grid item xs={12} sm={12} md={12}>
                  <Grid direction="row" container spacing={1} >
                    <Grid item xs={8} sm={8} md={8}>
                      <p><b>Analytics Users By Role  </b></p>
                    </Grid>
                    <Grid item xs={4} sm={4} md={4}>
                      <Box component="div" className="text-right" >
                        <Button >
                          <ZoomOutMapIcon style={{ float: "right" }} onClick={() => handleClickOpen(3, "usersbyrole")} />
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
                <UsersByChart title="Users By Role" datatype="usersbyrole" chartData={Userbyrolechart}></UsersByChart>
              </Box>

            </Grid>
            <Grid item xs={5} sm={5} md={5}>

              <Box p={2} className={classes.boxLayout} style={{ height: "468px" }} >
                <Grid item xs={12} sm={12} md={12}>
                  <Grid direction="row" container spacing={1} >
                    <Grid item xs={8} sm={8} md={8}>
                      <p><b>Analytics Users By Type</b>  </p>
                    </Grid>
                    <Grid item xs={4} sm={4} md={4}>
                      <Box component="div" className="text-right" >
                        <Button >
                          <ZoomOutMapIcon style={{ float: "right" }} onClick={() => handleClickOpen(1, "usersbyusertype")} />
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
                <UsersByChart title="Users By Type" datatype="usersbyusertype" chartData={Userbyusertypechart} ></UsersByChart>
              </Box>

              {/* <Box p={2} className={classes.boxLayout} >
                <Button >
                  <ZoomOutMapIcon style={{ float: "right" }} onClick={() => handleClickOpen(4, "usersbydevice")} />
                </Button>
                <UsersByChart title="Users By Device" datatype="usersbydevice" chartData={Userbydevicechart}></UsersByChart>
              </Box> */}


              {/* <Box p={2} className={classes.boxLayout} >
                <Button >
                  <ZoomOutMapIcon style={{ float: "right" }} onClick={() => handleClickOpen(5, "usersbybrowser")} />
                </Button>
                <UsersByChart title="Users By Browser" datatype="usersbybrowser" chartData={Userbybrowserchart}></UsersByChart>
              </Box>
              <Box p={2} className={classes.boxLayout} >
                <Button >
                  <ZoomOutMapIcon style={{ float: "right" }} onClick={() => handleClickOpen(8, 'usersbyloginfailed')} />
                </Button>
                <UsersByChart title="Users By loginfailed" datatype="usersbyloginfailed" chartData={loginfaileddetails}></UsersByChart>

              </Box> */}

            </Grid>
            {/* <Grid item xs={4} sm={4} md={4} >

              <Box p={2} className={classes.boxLayout} >
                <Button >
                  <ZoomOutMapIcon style={{ float: "right" }} onClick={() => handleClickOpen(6, "usersbyclient")} />
                </Button>
                <UsersByChart title="Users By Client" datatype="usersbyclient" chartData={Userbyclientchart}></UsersByChart>
              </Box>


              <Box p={2} className={classes.boxLayout} >
                <Button >
                  <ZoomOutMapIcon style={{ float: "right" }} onClick={() => handleClickOpen(7, "usersbyoperatingsystem")} />
                </Button>
                <UsersByChart title="Users By OS" datatype="usersbyoperatingsystem" chartData={Userbyoschart}></UsersByChart>
              </Box>



            </Grid> */}

            <Grid item xs={5} sm={5} md={5} >
              <Box p={2} className={classes.boxLayout} style={{ height: "468px" }} >
                <Grid item xs={12} sm={12} md={12}>
                  <Grid direction="row" container spacing={1} >
                    <Grid item xs={8} sm={8} md={8}>
                      <p><b>Analytics Users By Browser  </b></p>
                    </Grid>
                    <Grid item xs={4} sm={4} md={4}>
                      <Box component="div" className="text-right" >
                        <Button >
                          <ZoomOutMapIcon style={{ float: "right" }} onClick={() => handleClickOpen(5, "usersbybrowser")} />
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
                <UsersByChart title="Users By Browser" datatype="usersbybrowser" chartData={Userbybrowserchart}></UsersByChart>
              </Box>
            </Grid>
            <Grid item xs={7} sm={7} md={7} >
              <Box p={2} className={classes.boxLayout} style={{ height: "468px" }} >
                <Grid item xs={12} sm={12} md={12}>
                  <Grid direction="row" container spacing={1} >
                    <Grid item xs={8} sm={8} md={8}>
                      <p><b>Analytics Users By OS  </b></p>
                    </Grid>
                    <Grid item xs={4} sm={4} md={4}>
                      <Box component="div" className="text-right" >
                        <Button >
                          <ZoomOutMapIcon style={{ float: "right" }} onClick={() => handleClickOpen(7, "usersbyoperatingsystem")} />
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
                <UsersByChart title="Users By OS" datatype="usersbyoperatingsystem" chartData={Userbyoschart}></UsersByChart>
              </Box>

            </Grid>


            <Grid item xs={12} sm={12} md={12} >

              <Box p={2} className={classes.boxLayout} style={{ height: "468px" }} >
                <Grid item xs={12} sm={12} md={12}>
                  <Grid direction="row" container spacing={1} >
                    <Grid item xs={8} sm={8} md={8}>
                      <p><b>Analytics Users By Country </b> </p>
                    </Grid>
                    <Grid item xs={4} sm={4} md={4}>
                      <Box component="div" className="text-right" >
                        <Button >
                          <ZoomOutMapIcon style={{ float: "right" }} onClick={() => handleClickOpen(2, "usersbycountry")} />
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
                <UsersByChart title="Users By Country" datatype="usersbycountry" chartData={Userbycountrychart}></UsersByChart>
              </Box>
            </Grid>
            {/*  <Grid item xs={5} sm={5} md={5} >

              <Box p={2} className={classes.boxLayout} style={{ height: "468px" }} >
                <Grid item xs={12} sm={12} md={12}>
                  <Grid direction="row" container spacing={1} >
                    <Grid item xs={8} sm={8} md={8}>
                      <p><b>Analytics Users By loginfailed </b> </p>
                    </Grid>
                    <Grid item xs={4} sm={4} md={4}>
                      <Box component="div" className="text-right" >
                        <Button >
                          <ZoomOutMapIcon style={{ float: "right" }} onClick={() => handleClickOpen(8, 'usersbyloginfailed')} />
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
                <UsersByChart title="Users By loginfailed" datatype="usersbyloginfailed" chartData={loginfaileddetails}></UsersByChart>
              </Box>





            </Grid> */}
           
            <Grid className="reportstablehead" item xs={12} sm={12} md={12}>
              <Box p={2} className={classes.boxLayout} >
                <Box component="div" bgcolor="#fff" boxShadow={1} borderRadius={6}>
                  {/* <Box
                    component="div"
                    bgcolor="#1A1A31"
                    py={1.0}
                    px={3}
                    fontWeight={600}
                    fontSize={15}
                    color="#fff"
                    className={classes.boxBorder}
                  >
                    <Box display="flex" className={classes.justifyContentBetween}>
                      <Box component="span" fontSize="18px">
                        Failed Login Details
                      </Box>
                      <Box
                        component="span"
                        width="0.03"
                        className={classes.overflowHidden}
                      >
                      </Box>
                    </Box>
                  </Box> */}

                  <Box component="div"  >
                    <Box component="div">
                      {/* <TableContainer className={classes.tableLayout}>
                        <Table className={classes.table} aria-label="customized table">
                          <TableHead>
                            <TableRow>

                              <StyledTableCell>User Name</StyledTableCell>
                              <StyledTableCell>TimeStamp</StyledTableCell>
                              <StyledTableCell>Email</StyledTableCell>
                              <StyledTableCell>Location</StyledTableCell>
                            </TableRow>
                          </TableHead>



                          <TableBody>
                            {loginfailedtable.length > 0 ? loginfailedtable.map((row, index) => {
                              return (
                                <TableRow>
                                  <StyledTableCell>{row.username}</StyledTableCell>
                                  <StyledTableCell>{row.timestamp}</StyledTableCell>
                                  <StyledTableCell>{row.email}</StyledTableCell>
                                  {/* <StyledTableCell>{row.reason}</StyledTableCell>  */}
                      {/*<StyledTableCell>{row.location}</StyledTableCell>
                                </TableRow>
                              )
                            }) : ""}*/}{/*
                          </TableBody>

                        </Table>
                      </TableContainer> */}
                      <ThemeProvider theme={getMuiTheme()}>
                        <MUIDataTable
                          title={"Login Failed Details"}
                          className={classes.tableBody}
                          data={loginfailedtable}

                          columns={column}
                          options={option}
                        />
                        {/* <Confirmation open={openAlert} onClose={handleClose} onHandleSubmit={onAlertSubmit} BMhistorydata={Bunkermasterhistory} /> */}
                      </ThemeProvider>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Grid>


          </Grid>
        </TabPanel>
        <TabPanel value={value} index={1} className="custom-tab-section">

          <ThemeProvider theme={getMuiTheme()}>
            <MUIDataTable
              title={"Analytics List"}
              className={classes.AnalyticstableBody}
              data={Analyticstable}
              columns={columns}
              options={options}
            />

          </ThemeProvider>

        </TabPanel>


      </Grid>
    </>
  );
}

export default UserAnalytics;